<template>
    <div>
        <div>
            <div class="detail-header-container">
                <h4 class="page-title">Header Configuration</h4>
                <div class="round-btn" @click="closeDetailPage()"><i class="fas fa-times"></i></div>
            </div>
            
            <p class="conf-title">Table Column</p>
            <draggable v-model="myArray" group="people" v-bind="dragOptions" @end="onEnd">
                <transition-group>
                    <dragable-item 
                    :item="element" 
                    v-for="(element, index) in myArray" 
                    :key="'array' + index" 
                    @updateVisibleItem="updateVisibleItem"/>
                </transition-group>
            </draggable>
            <div class="empty-field-container" v-if="!myArray || myArray.length == 0">
                <p>Empty</p>
            </div>
        </div>
        
        <div>
            <p class="conf-title">Hidden Column</p>
            <el-input
                placeholder="Search"
                class="search-input"
                size="mini"
                v-model="search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            
            <hidden-item 
                :item="element"
                v-for="(element, index) in myArray2" 
                :key="'array'+index" 
                @updateHiddenItem="updateHiddenItem"
            ></hidden-item>

            <div class="empty-field-container" v-if="!myArray2 || myArray2.length == 0">
                <p>Empty</p>
            </div>
        </div>

        <save-btn class="save-btn" @confirmSave="confirmSave()"></save-btn>
    </div>
</template>

<script>
import DragableItem from '@/components/TableConfiguration/DragableItem'
import HiddenItem from '@/components/TableConfiguration/HiddenItem'
import draggable from 'vuedraggable'
import SaveButton from '@/components/Button/SaveButton'
import { mapGetters } from 'vuex'
import { customFieldGetHeaders } from '@/api/custom_field'
import { tableHeaderConfigurationGetHeaders, tableHeaderConfigurationStoreHeaders } from '@/api/table_header_configuration'

    export default {
        components: {
            'draggable': draggable,
            'dragable-item': DragableItem,
            'hidden-item': HiddenItem,
            'save-btn': SaveButton,
        },
        data() {
            return {
                myArray: [],
                myArray2: [],
                
                // myArray: [
                //     { id: 1, name: '[123', label: '[123', isShown: false },
                //     { id: 2, name: 'name', label: 'name', isShown: false },
                //     { id: 3, name: 'state', label: 'state', isShown: false },
                // ],
                
                // myArray2: [
                //     { id: 4, dataName: 'city', displayName: 'city', isShown: false },
                //     { id: 5, dataName: 'address', displayName: 'address', isShown: false },
                //     { id: 6, dataName: 'zip', displayName: 'zip', isShown: false },
                // ],

                search: null
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "people",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            ...mapGetters([
                'info_sidebar_id',
                'info_details'
            ]),
        },
        methods: {
            onEnd(event) {
                this.$store.dispatch('field_header/setVisibleFieldHeader', this.myArray);
            },
            getDemoHeader() {
                this.$store.dispatch('field_header/setVisibleFieldHeader', this.myArray);
                this.$store.dispatch('field_header/setHiddenFieldHeader', this.myArray2);
            },
            async getAllHeader() {
                if(this.info_details && Object.keys(this.info_details).length != 0) {
                    var result = await tableHeaderConfigurationGetHeaders(this.$store.state.info_sidebar.info_details);
                    if(result.items && result.items.length > 0) {
                        this.splitVisibleAndHiddenHeader(result.items)
                    }
                }
            },
            splitVisibleAndHiddenHeader(headers) {
                let visible = headers.filter(header => header.isShown == true)
                let hidden = headers.filter(header => header.isShown == false)

                this.myArray.push(...visible)
                this.$store.dispatch('field_header/setVisibleFieldHeader', this.myArray);

                this.myArray2.push(...hidden)
                this.$store.dispatch('field_header/setHiddenFieldHeader', this.myArray2);
            },
            getHiddenHeader() {
                this.$store.dispatch('field_header/setHiddenFieldHeader', this.myArray2);
            },
            updateVisibleItem(_dataName) {
                var selected_field = this.myArray.find(item => item.dataName === _dataName);
                var selected_index = this.myArray.findIndex(item => item.dataName === _dataName);
                selected_field.isShown = false
                this.myArray.splice(selected_index, 1)
                this.myArray2.push(selected_field)
            },
            updateHiddenItem(_dataName) {
                var selected_field = this.myArray2.find(item => item.dataName === _dataName);
                var selected_index = this.myArray2.findIndex(item => item.dataName === _dataName);
                selected_field.isShown = true
                this.myArray2.splice(selected_index, 1)
                this.myArray.push(selected_field)
            },
            async confirmSave() {
                this.myArray.forEach((item, index) => item.sequence = index + 1)
                let data = {
                    ...this.info_details,
                    'headers': [...this.myArray]
                }
                console.log('data', data)
                let res = await tableHeaderConfigurationStoreHeaders(data)
                if(res) {
                    this.$_triggerSuccessNotify('Success Update Table Configuration')
                    this.$store.dispatch('info_sidebar/setInfoSidebarObject', {});
                    this.$_closeSidebarWithChecking()
                }
            },
            closeDetailPage() {
                this.$store.dispatch('info_sidebar/setInfoSidebar');
            },
        },
        mounted() {
            this.getAllHeader()
            // this.getHiddenHeader()
            // this.getDemoHeader()
        },
        watch: {
            info_details() {
                this.myArray = []
                this.myArray2 = []
                this.getAllHeader()
            }
        }
    }
</script>

<style lang="css" scoped>
.conf-title  {
    margin: var(--space-24) 0 var(--space-8) 0;
    font-weight: 700;
}
.search-input {
    margin-bottom: var(--space-8);
}
.empty-field-container {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%239b9b9b' stroke-width='2' stroke-dasharray='4%2c 16' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.save-btn {
    margin-top: var(--space-24);
}
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/TableConfigurationSidebar.vue